<template>
  <div class="popUpWrap">
    <section class="popup dark assessment">
      <div class="topArea">
        <div class="exit" @click.stop="onClickClose"></div>
      </div>
      <div class="scrollY">
        <div class="icon rec"></div>
        <div class="textArea flex">
          <h5 v-html="convertToNextLine(t('skillCertify-proctoring-entire-screen-recording-no-access-title'))"></h5>
        </div>
        <div class="boxArea">
          <ul class="listDot">
            <li v-if="externalDirectorService.isMac" v-html="convertToNextLine(t('skillCertify-proctoring-entire-screen-recording-no-access-description-1') + '<br/>' + t('learning-assessment-guide-line-description-for-mac-2') + '<span>' + t(externalDirectorService.isCodepressoWebview ? 'learning-assessment-guide-line-description-for-mac-4' : 'learning-assessment-guide-line-description-for-mac-3') + '</span>')"></li>
            <li>{{ t("skillCertify-proctoring-entire-screen-recording-no-access-description-2") }}</li>
          </ul>
        </div>
        <p class="contactText" v-html="t('skillCertify-proctoring-entire-screen-recording-no-access-description-3', { email: supportEmailHtml })"></p>
        <div class="btnArea">
          <button @click.stop="onClickClose">{{ t("common-ok") }}</button>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import {useDialogStore} from "~/store/dialog/dialogStore";
import {convertToNextLine, useI18n} from "#imports";
import { useExternalDirectorService } from "~/composables/service/useExternalDirectorService";

const { t } = useI18n();

const externalDirectorService = useExternalDirectorService();

const supportEmailHtml = '<a href="mailto:support@codepresso.io">support@codepresso.io</a>';

const dialogStore = useDialogStore();
const onClickClose = () => {
  dialogStore.options.close?.event()
  dialogStore.close()
}
</script>

<style scoped>
.contactText {
  margin-top: 16px;
}
</style>

